// eslint-disable-next-line
import html2pdf from 'html2pdf.js';
import ActionButton from '../input-fields/ActionButton';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { FieldVariants } from '../input-fields/utils/appInputenum';
import { useState } from 'react';
import { transactionTableToHtml } from './HtmlConversionFunctions';

const PdfTemplateDownload = (props) => {

  //#region props
  const { companyDetails, isSaveEnabled,analysisDetails } = props;

  //#region variables
  const [loading, setLoading] = useState(false);

  //#region click events
  const downloadPDF = async () => {
    setLoading(true);
    const response = await fetch('/templates/CompanyTemplate.html');
    let templateHTML = await response.text();

    templateHTML = templateHTML
      .replace('${companyName}', companyDetails?.basicDetails?.companyName || '')
      .replace('${Founded}', companyDetails?.basicDetails?.founded || '')
      .replace('${Headquarters}', companyDetails?.basicDetails?.headquarters || '')
      .replace('${dealBackground}', companyDetails?.dealBackground || '')
      .replace('${revenueModel}', companyDetails?.revenueModel || '')
      .replace('${companyOverview}', companyDetails?.companyOverview || '')
      /* .replace('${transaction}', transactionTableToHtml(companyDetails["transactionColumns"],companyDetails?.transaction) || '') */
      .replace('${marketCompetition}', companyDetails?.marketCompetition || '')
      .replace('${investmentSummary}', companyDetails?.investmentSummary || '')
      .replace('${plSnapshot}', companyDetails?.plSnapshot || '')
      .replace('${customers}', companyDetails?.customers || '')
      
    const documentName = analysisDetails?.uploadedDocmentName?.split(".")[0] || "Document";
    debugger
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10); // YYYY-MM-DD
    const fileNameFormat = `Investment_Concept_${documentName}_${formattedDate}.pdf`;

    // Extract <style> tags from <head>
    const styleMatches = templateHTML.match(/<style[^>]*>([\s\S]*?)<\/style>/gi);
    const styles = styleMatches ? styleMatches.join('\n') : '';

    // Extract only the body content
    const bodyMatch = templateHTML.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    const bodyContent = bodyMatch ? bodyMatch[1] : templateHTML;

    // Create a wrapper and inject styles + body
    const element = document.createElement('div');
    element.innerHTML = `${styles}${bodyContent}`;

    html2pdf()
      .set({
        margin: 10,
        filename: fileNameFormat,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      })
      .from(element)
      .save()
      .finally(() => setLoading(false));
  };

  //#region return
  return (
    <ActionButton
      icon={<ExitToAppIcon />}
      variant={FieldVariants.OUTLINED}
      label="Export to PDF"
      loading={loading}
      onClick={downloadPDF}
      disabled={isSaveEnabled || loading}
    />
  );
};

export default PdfTemplateDownload;
